import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { KeyRound, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const API_ROOT = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReaderResetPasswordPage() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (password !== confirm) { toast.error("Le password non coincidono"); return; }
        setBusy(true);
        try {
            const res = await fetch(`${API_ROOT}/reader/reset-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, password, password_confirm: confirm }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.detail || "Errore reimpostazione password");
            setDone(true);
        } catch (err) {
            toast.error(err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-4 md:mt-10">
            <h1 className="pvx-serif text-3xl tracking-tight mb-2">Reimposta la password</h1>
            <p className="text-[13.5px] text-pvx-textmuted mb-8">
                Scegli una nuova password per il tuo account lettore.
            </p>

            {done ? (
                <div className="pvx-card p-6 md:p-7 text-center" data-testid="reset-success">
                    <CheckCircle2 size={24} strokeWidth={1.5} className="mx-auto text-pvx-success mb-3" />
                    <div className="text-[14px] font-medium mb-1.5">Password aggiornata</div>
                    <div className="text-[12.5px] text-pvx-textmuted mb-5">
                        Ora puoi accedere con la tua nuova password.
                    </div>
                    <Link to="/reader/login" className="text-pvx-primary text-[13px] hover:underline">Vai al login</Link>
                </div>
            ) : (
                <form onSubmit={submit} className="pvx-card p-6 md:p-7 space-y-4" data-testid="reader-reset-form">
                    <div>
                        <label className="pvx-eyebrow mb-1.5 block">Nuova password</label>
                        <input
                            data-testid="reset-password"
                            type="password" required minLength={8}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full h-10 px-3 rounded-[10px] border border-pvx-border bg-pvx-surface/60 focus:bg-pvx-surface focus:border-pvx-primary/50 text-[13.5px] outline-none transition-colors"
                            autoComplete="new-password"
                        />
                    </div>
                    <div>
                        <label className="pvx-eyebrow mb-1.5 block">Conferma password</label>
                        <input
                            data-testid="reset-password-confirm"
                            type="password" required minLength={8}
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            className="w-full h-10 px-3 rounded-[10px] border border-pvx-border bg-pvx-surface/60 focus:bg-pvx-surface focus:border-pvx-primary/50 text-[13.5px] outline-none transition-colors"
                            autoComplete="new-password"
                        />
                    </div>
                    <button
                        data-testid="reset-submit"
                        type="submit"
                        disabled={busy}
                        className="w-full flex items-center justify-center gap-2 bg-pvx-primary text-white rounded-[10px] py-2.5 text-[13.5px] font-medium hover:opacity-90 disabled:opacity-60 transition-opacity"
                    >
                        {busy ? <Loader2 size={14} strokeWidth={1.5} className="animate-spin" /> : <KeyRound size={14} strokeWidth={1.5} />}
                        Salva nuova password
                    </button>
                    <div className="pt-1 text-center text-[12.5px] text-pvx-textmuted">
                        <Link to="/reader/login" className="text-pvx-primary hover:underline">Torna al login</Link>
                    </div>
                </form>
            )}
        </div>
    );
}
